<template>
  <v-container fluid>
    <v-card height="auto" min-height="800">
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Menus</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-alert :color=AlertColor(type)
                 :dismissible="true"
                 :value=true
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 transition="slide-y-transition"
                 v-if="type">
          {{ text }}
        </v-alert>
        <v-alert border="top" class="my-4" color="#F44336" dark dense v-if="errors.length>0"
                 v-model="alert">
          <h4 class="mt-2">{{ errors.length }}{{ " Erreur" | pluralize(errors.length) }}
            sur {{ excelData.length }} {{ "enregistrement"|pluralize(excelData.length) }}.
            Merci de corriger et de ne réimporter que les Menus ci-dessous rejetés, pour éviter tout
            doublon.
          </h4>
          <v-row align="center">
            <v-col class="grow">
              <div :key="index" v-for="(error,index) in errors">
                <h5>
                  <v-icon>mdi-alert-circle</v-icon>
                  {{ "Menu (" + error.datas.name + ") -> " + error.message }}
                </h5>
              </div>
            </v-col>
            <v-col class="shrink">
              <v-btn :elevation="1" @click="closeAlert" fab small
                     style="position:absolute;top:18px;right:12px">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <v-card class="mt-1" flat
                tile>
          <v-row>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="bDisplayOK_Corinne">
              <v-btn @click="onexportModele" block class="custom-btn white--text" color="#03A9F4"
                     height="45px"
                     large>
                <v-icon class="mr-1">mdi-download-circle-outline</v-icon>
                <span>Export modèle</span>
              </v-btn>
            </v-col>
            <v-col v-else>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="bDisplayOK_Corinne">
              <v-dialog max-width="900px" persistent v-model="dialog" style="z-index:400">
                <template @mouseleave.native="hover = false" @mouseover.native="hover = true"
                          v-slot:activator="{ on }">
                  <v-btn @click="init()" block class="custom-btn white--text" color="#009688"
                         height="45px" large v-on="on">
                    <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                    <span>Gestion repas</span>
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar
                      color="#01579B"
                      dark
                      flat>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="close"
                        dark
                        fab
                        small>
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-tabs :grow=true background-color="#01579B" color="#f5f5f5" dark="" right
                          v-model="tab">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab-1"> Ajouter menu</v-tab>
                    <v-tab href="#tab-2"> Modifier menu</v-tab>
                    <v-tab href="#tab-3"> Import fichier Menus</v-tab>
                    <v-tab href="#tab-4"> Import simplifié</v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tab">
                    <v-alert :color=AlertColorDlg(typeDlg)
                             :dismissible=true
                             :value=true
                             @input="dismissible_close_dlg"
                             border="bottom"
                             class="pre-formatted multi-line"
                             colored-border
                             elevation="2"
                             icon="check_circle"
                             v-if="typeDlg">
                      {{ textDlg }}
                    </v-alert>
                    <v-tab-item style="background-color:#E3F2FD" value="tab-1">
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12" md="8" sm="12">
                              <v-combobox :id="dynamicID()" clearable
                                          :items="products"
                                          @change="uploadProduct"
                                          class="centered-input align-center text-center"
                                          label="Nom du menu"
                                          persistent-hint
                                          prepend-inner-icon="mdi-food"
                                          v-model="editedItem.productName"
                              ></v-combobox>
                            </v-col>
                            <v-col cols="12" md="4" sm="12">
                              <v-combobox :id="dynamicID()" clearable
                                          :items="restaurateurs"
                                          @change="FormIsValidAdd"
                                          class="centered-input align-center text-center"
                                          label="Restaurateur"
                                          persistent-hint
                                          :disabled="bHideRestaurateur"
                                          prepend-inner-icon="mdi-silverware-fork-knife"
                                          v-model="editedItem.restaurateur"
                              ></v-combobox>
                            </v-col>
                          </v-row>
                          <v-row class="justify-center align-center">
                            <v-col cols="12" md="6" sm="12" v-if="bDisplayOK_Corinne">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input align-center"
                                            label="Prix du menu"
                                            prepend-inner-icon="mdi-cash-multiple"
                                            v-model="editedItem.productPrice"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6" sm="12">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input align-center"
                                            label="Description"
                                            prepend-inner-icon="mdi-comment-edit-outline"
                                            v-model="editedItem.productDescription"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row class="justify-center align-center" v-if="bDisplayOK_Corinne">
                            <v-radio-group row v-model="radiosFree">
                              <v-radio color="green" value="agent_account">
                                <template v-slot:label>
                                  <div><strong
                                      class="success--text"
                                      style="color:#FFA500; margin-right: 30px;">Compte
                                    agent</strong>
                                  </div>
                                </template>
                              </v-radio>
                              <v-radio color="primary" value="tsa_account">
                                <template v-slot:label>
                                  <div><strong
                                      class="primary--text">Compte TSA</strong>
                                  </div>
                                </template>
                              </v-radio>
                            </v-radio-group>
                          </v-row>
                          <v-row class="justify-center align-center">
                            <v-checkbox @change="deleteDinerA" color="#ED7F10" row style="padding-bottom: 15px;"
                                        v-model="editedItem.timeMeal" value="Déjeuner">
                                                            <span slot="label"
                                                                  style="color:#ED7F10; margin-right: 30px;">"Déjeuner"</span>
                            </v-checkbox>
                            <v-checkbox @change="deleteDejeunerA" color="#C71585" row style="padding-bottom: 15px;"
                                        v-model="editedItem.timeMeal" value="Diner">
                              <span slot="label" style="color:#C71585;">"Dîner"</span>
                            </v-checkbox>
                          </v-row>
                          <v-row class="justify-center align-center">
                            <v-card class="d-flex align-center justify-center" flat
                                    min-height="250">
                              <v-date-picker
                                  locale="fr-FR"
                                  multiple
                                  scrollable
                                  v-model="editedItem.planningDates"
                              >
                              </v-date-picker>
                            </v-card>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-row class="justify-center align-center">
                        <v-col cols="12" md="6" sm="12">
                          <v-card-actions class="d-flex align-center justify-center" flat>
                            <v-btn :disabled="!FormIsValidAdd && !loading" @click="ajouter"
                                   class="white--text"
                                   color="#01579B" depressed>Ajouter
                            </v-btn>
                          </v-card-actions>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item style="background-color:#FFFDE7" value="tab-2">
                      <v-card-text>
                        <v-container>
                          <v-row class="justify-center align-center">
                            <v-col cols="12" md="12" sm="12">
                              <v-autocomplete :id="dynamicID()" clearable
                                              :items="products"
                                              @change="uploadProduct"
                                              class="centered-input align-center text-center"
                                              label="Nom du menu"
                                              persistent-hint
                                              prepend-inner-icon="mdi-food"
                                              v-model="editedItemModif.productName">
                              </v-autocomplete>
                            </v-col>
                          </v-row>
                          <v-row class="justify-center align-center">
                            <v-col cols="12" md="6" sm="12" v-if="bDisplayOK_Corinne">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input align-center"
                                            label="Prix du menu"
                                            prepend-inner-icon="mdi-cash-multiple"
                                            v-model="editedItemModif.productPrice"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6" sm="12">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input align-center"
                                            label="Description"
                                            prepend-inner-icon="mdi-comment-edit-outline"
                                            v-model="editedItemModif.productDescription"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row class="justify-center align-center" v-if="bDisplayOK_Corinne">
                            <v-radio-group row v-model="radiosFree">
                              <v-radio color="green" value="agent_account">
                                <template v-slot:label>
                                  <div><strong
                                      class="success--text">Compte
                                    agent</strong>
                                  </div>
                                </template>
                              </v-radio>
                              <v-radio color="primary" value="tsa_account">
                                <template v-slot:label>
                                  <div><strong
                                      class="primary--text">Compte TSA</strong>
                                  </div>
                                </template>
                              </v-radio>
                            </v-radio-group>
                          </v-row>
                          <v-row class="justify-center align-center">
                            <v-checkbox color="#ED7F10" row
                                        @change="deleteDinerM"
                                        style="padding-bottom: 15px;"
                                        v-model="editedItemModif.timeMeal"
                                        value="Déjeuner">
                                                            <span slot="label"
                                                                  style="color:#ED7F10; margin-right: 30px;">"Déjeuner"</span>
                            </v-checkbox>
                            <v-checkbox color="#C71585" row
                                        @change="deleteDejeunerM"
                                        style="padding-bottom: 15px;"
                                        v-model="editedItemModif.timeMeal"
                                        value="Diner">
                              <span slot="label" style="color:#C71585;">"Dîner"</span>
                            </v-checkbox>
                          </v-row>
                          <v-row class="justify-center align-center">
                            <v-card class="d-flex align-center justify-center" flat
                                    min-height="250">
                              <v-date-picker
                                  locale="fr-FR"
                                  multiple
                                  scrollable
                                  v-model="editedItemModif.planningDates"
                              >
                              </v-date-picker>
                            </v-card>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-row class="justify-center align-center">
                        <v-col cols="12" md="6" sm="12">
                          <v-card-actions class="d-flex align-center justify-center" flat>
                            <v-btn :disabled="!FormIsValidSupp && !loading"
                                   @click="supprimer"
                                   class="white--text"
                                   color="#FD4626" depressed>Supprimer
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn :disabled="!FormIsValidModif && !loading"
                                   @click="modifier"
                                   class="white--text"
                                   color="#FAA401" depressed>Modifier
                            </v-btn>
                          </v-card-actions>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item value="tab-3">
                      <v-card v-if="!file">
                        <v-container v-if="loading">
                          <div class="text-center">
                            <v-progress-circular color="green" indeterminate>
                            </v-progress-circular>
                          </div>
                        </v-container>
                        <v-btn :disabled="!fileBtn" @click="onPickFile" block
                               class="mr-2 mb-2" large
                               style="color:#01579B; background-color:#F5F5F5" v-if="!loading">
                          <v-icon>mdi-paperclip</v-icon>
                          Importer ICI ou Glisser/Copier le fichier Excel ci-dessous
                        </v-btn>
                        <input @change="onFilePicked($event)" accept="xlsx/*" id="upload"
                               ref="fileInput"
                               style="display:none" type="file"/>
                      </v-card>
                      <v-card>
                        <div class="text-center">
                          <v-card-text>
                            <v-chip color="white" disabled label small
                                    v-if="file">
                              {{ file.name }} ({{ file.size | kb }} kb)
                            </v-chip>
                            <v-btn @click="removeFile(file)"
                                   title="Supprimer"
                                   v-if="file">
                              <v-icon style="color:darkred;">
                                mdi-delete-circle-outline
                              </v-icon>
                            </v-btn>
                            <template>
                              <div ref="others">
                                <div :class="['downbox', drag_over ? 'over' : '']"
                                     @dragenter="dragEnter"
                                     @dragleave="dragLeave"
                                     @dragover.prevent
                                     @drop.prevent="addFile"
                                     @ondragover="dragOver"
                                     v-cloak>
                                  <v-btn
                                      color="primary"
                                      height="100px"
                                      outlined
                                      v-if="!file"
                                      width="100%"
                                  >
                                  </v-btn>
                                </div>
                              </div>
                              <v-spacer></v-spacer>
                              <v-btn :disabled="loading" :loading="loading"
                                     @click.prevent="importFileToHandsonTableMenus"
                                     color="#009688" dark
                                     depressed
                                     fab
                                     v-if="file">
                                <v-icon>mdi-cloud-upload</v-icon>
                                <span class="custom-loader" slot="loader">
                                                                        <v-icon color="white" light>cached</v-icon>
                                                                        </span>
                              </v-btn>
                            </template>
                          </v-card-text>
                        </div>
                      </v-card>
                    </v-tab-item>
                    <!-- Nouveau tab pour import simplifié -->
                    <v-tab-item value="tab-4">
                      <MenuBulkImport 
                        v-if="tab === 'tab-4'"
                        :products="fullProducts"
                        :restaurateurs="restaurateurs"
                        @success="onBulkImportSuccess"
                        @error="onBulkImportError"
                        @close="tab = 'tab-1'"
                      />
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card>

        <!-- Desktop Calendar View with Vuetify v-calendar -->
        <div v-if="!isMobile" class="desktop-vuetify-calendar">
          <!-- Loading Overlay -->
          <v-overlay :value="isLoadingMenus" opacity="0.8" color="white" style="z-index: 100;">
            <v-container>
              <v-row align="center" justify="center" class="fill-height">
                <v-col cols="12" class="text-center">
                  <v-progress-circular
                      :size="70"
                      :width="7"
                      color="#009688"
                      indeterminate
                  ></v-progress-circular>
                  <p class="mt-4 text-h6" style="color: #009688;">
                    Chargement du calendrier des menus...
                  </p>
                </v-col>
              </v-row>
            </v-container>
          </v-overlay>

          <!-- Calendar Controls -->
          <v-card class="mb-4" flat>
            <v-card-text>
              <v-row align="center">
                <v-col cols="4">
                  <v-btn-toggle v-model="calendarType" mandatory>
                    <v-btn value="month">
                      <v-icon left>mdi-calendar-month</v-icon>
                      Mois
                    </v-btn>
                    <v-btn value="week">
                      <v-icon left>mdi-calendar-week</v-icon>
                      Semaine
                    </v-btn>
                    <v-btn value="day">
                      <v-icon left>mdi-calendar-today</v-icon>
                      Jour
                    </v-btn>
                  </v-btn-toggle>
                </v-col>
                <v-col cols="4" class="text-center">
                  <v-btn @click="setToday" color="primary" outlined class="mr-2">
                    Aujourd'hui
                  </v-btn>
                  <v-btn @click="$refs.calendar.prev()" icon>
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>
                  <span class="mx-3 text-h6 font-weight-bold" style="color: #009688;">
                    {{ getCurrentMonthYear() }}
                  </span>
                  <v-btn @click="$refs.calendar.next()" icon>
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="4" class="text-right">
                  <v-text-field
                      v-model="calendarSearchQuery"
                      append-icon="mdi-magnify"
                      label="Rechercher un menu"
                      single-line
                      hide-details
                      outlined
                      dense
                      clearable
                      @input="filterCalendarEvents"
                      style="max-width: 300px; margin-left: auto;"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Vuetify Calendar -->
          <v-card>
            <v-calendar
                ref="calendar"
                v-model="focus"
                color="primary"
                :events="filteredCalendarEvents"
                :event-color="getEventColor"
                :type="calendarType"
                @click:event="showEventDetails"
                @click:more="viewDay"
                @click:date="viewDay"
                @change="updateRange"
                locale="fr-fr"
            >
              <!-- Custom event rendering sans heures -->
              <template v-slot:event="{ event }">
                <div class="vuetify-event">
                  <v-icon
                      small
                      class="mr-1"
                      color="white"
                  >
                    {{ event.timeMeal === 'Déjeuner' ? 'mdi-weather-sunny' : 'mdi-weather-night' }}
                  </v-icon>
                  <span class="event-title">{{ event.name }}</span>
                </div>
              </template>
            </v-calendar>
          </v-card>

          <!-- Event Details Dialog -->
          <v-dialog v-model="selectedOpen" max-width="600px">
            <v-card v-if="selectedEvent">
              <v-card-title class="headline d-flex align-center">
                <v-avatar
                    :color="selectedEvent.timeMeal === 'Déjeuner' ? '#ED7F10' : '#C71585'"
                    class="mr-3"
                >
                  <v-icon dark>
                    {{ selectedEvent.timeMeal === 'Déjeuner' ? 'mdi-weather-sunny' : 'mdi-weather-night' }}
                  </v-icon>
                </v-avatar>
                {{ selectedEvent.name }}
                <v-spacer></v-spacer>
                <v-btn icon @click="selectedOpen = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text>
                <v-list>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="#ED7F10">mdi-clock-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Heure & Service</v-list-item-title>
                      <v-list-item-subtitle>{{ selectedEvent.time }} - {{ selectedEvent.timeMeal }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="#03A9F4">mdi-calendar</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Date</v-list-item-title>
                      <v-list-item-subtitle>{{ formatDate(selectedEvent.start || selectedEvent.dateKey || new Date()) }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item v-if="selectedEvent.description">
                    <v-list-item-icon>
                      <v-icon color="#4CAF50">mdi-text</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Description</v-list-item-title>
                      <v-list-item-subtitle>{{ selectedEvent.description }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item v-if="selectedEvent.price">
                    <v-list-item-icon>
                      <v-icon color="#FF9800">mdi-cash</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Prix</v-list-item-title>
                      <v-list-item-subtitle>{{ selectedEvent.price }} FCFA</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item v-if="selectedEvent.restaurateur">
                    <v-list-item-icon>
                      <v-icon color="#9C27B0">mdi-silverware-fork-knife</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Restaurateur</v-list-item-title>
                      <v-list-item-subtitle>{{ selectedEvent.restaurateur }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>

        <!-- Mobile View -->
        <div v-else class="mobile-menu-container">
          <!-- Afficher les skeletons pendant le chargement -->
          <template v-if="isLoadingMenus">
            <v-row class="mb-4">
              <v-col cols="12">
                <!-- Skeleton pour les filtres de date -->
                <v-skeleton-loader
                    type="chip@3"
                    class="mb-4"
                ></v-skeleton-loader>
                <!-- Skeleton pour les boutons de vue -->
                <v-skeleton-loader
                    type="button@2"
                    class="mb-4"
                ></v-skeleton-loader>
                <!-- Skeleton pour la barre de recherche -->
                <v-skeleton-loader
                    type="text"
                    class="mb-4"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <!-- Skeletons pour les cartes de menu -->
            <v-row>
              <v-col cols="12">
                <v-skeleton-loader
                    v-for="i in 3"
                    :key="i"
                    type="card"
                    class="mb-4"
                    elevation="2"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
          </template>

          <!-- Contenu normal quand chargé -->
          <template v-else>
            <!-- Date Filter and View Toggle -->
            <v-row class="mb-4">
              <v-col cols="12">
                <v-chip-group
                    v-model="selectedDateFilter"
                    active-class="primary--text"
                    column
                >
                  <v-chip
                      filter
                      outlined
                      color="primary"
                      @click="setDateFilter('today')"
                  >
                    Aujourd'hui
                  </v-chip>
                  <v-chip
                      filter
                      outlined
                      color="primary"
                      @click="setDateFilter('week')"
                  >
                    Cette semaine
                  </v-chip>
                  <v-chip
                      filter
                      outlined
                      color="primary"
                      @click="setDateFilter('month')"
                  >
                    Ce mois
                  </v-chip>
                </v-chip-group>
              </v-col>
            </v-row>

            <!-- Toggle View Type -->
            <v-row class="mb-4">
              <v-col cols="12">
                <v-btn-toggle
                    v-model="mobileViewType"
                    color="primary"
                    group
                    mandatory
                >
                  <v-btn value="list">
                    <v-icon left>mdi-view-list</v-icon>
                    Liste
                  </v-btn>
                  <v-btn value="cards">
                    <v-icon left>mdi-view-grid</v-icon>
                    Cartes
                  </v-btn>
                </v-btn-toggle>
              </v-col>
            </v-row>

            <!-- Search Bar -->
            <v-row class="mb-4">
              <v-col cols="12">
                <v-text-field
                    v-model="searchQuery"
                    append-icon="mdi-magnify"
                    label="Rechercher un menu"
                    single-line
                    hide-details
                    outlined
                    dense
                    clearable
                    @input="filterMobileMenus"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- List View -->
            <v-row v-if="mobileViewType === 'list'">
              <v-col cols="12">
                <v-expansion-panels
                    v-model="expansionPanel"
                    accordion
                    popout
                >
                  <v-expansion-panel
                      v-for="(dayData, index) in filteredMobileMenuData"
                      :key="index"
                  >
                    <v-expansion-panel-header class="mobile-day-header">
                      <div class="d-flex align-center justify-space-between" style="width: 100%">
                        <strong>{{ formatDateHeader(dayData.date) }}</strong>
                        <v-chip
                            x-small
                            color="primary"
                            text-color="white"
                        >
                          {{ dayData.menus.length }} menu{{ dayData.menus.length > 1 ? 's' : '' }}
                        </v-chip>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-list>
                        <v-list-item
                            v-for="(menu, menuIndex) in dayData.menus"
                            :key="menuIndex"
                            @click="showMobileMenuDetails(menu)"
                            class="mobile-menu-item"
                        >
                          <v-list-item-avatar>
                            <v-icon :color="menu.timeMeal === 'Déjeuner' ? '#ED7F10' : '#C71585'">
                              {{ menu.timeMeal === 'Déjeuner' ? 'mdi-weather-sunny' : 'mdi-weather-night' }}
                            </v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title class="font-weight-medium">
                              {{ menu.title }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <v-chip
                                  x-small
                                  :color="menu.timeMeal === 'Déjeuner' ? '#ED7F10' : '#C71585'"
                                  text-color="white"
                                  class="mr-2"
                              >
                                {{ menu.timeMeal }} - {{ menu.time }}
                              </v-chip>
                              <span v-if="menu.description">{{ menu.description }}</span>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-icon>mdi-chevron-right</v-icon>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>

            <!-- Cards View -->
            <v-row v-else>
              <v-col cols="12">
                <div class="mobile-cards-container">
                  <v-card
                      v-for="(dayData, index) in filteredMobileMenuData"
                      :key="index"
                      class="mb-4"
                      elevation="2"
                  >
                    <v-card-title class="mobile-card-header py-2 text-center">
                      <span class="text-subtitle-1 d-block w-100">{{ formatDateHeader(dayData.date) }}</span>
                    </v-card-title>
                    <v-card-text>
                      <div
                          v-for="(menu, menuIndex) in dayData.menus"
                          :key="menuIndex"
                          class="mobile-menu-card"
                          @click="showMobileMenuDetails(menu)"
                      >
                        <v-row align="center">
                          <v-col cols="2">
                            <v-avatar
                                :color="menu.timeMeal === 'Déjeuner' ? '#ED7F10' : '#C71585'"
                                size="40"
                            >
                              <v-icon dark>
                                {{ menu.timeMeal === 'Déjeuner' ? 'mdi-weather-sunny' : 'mdi-weather-night' }}
                              </v-icon>
                            </v-avatar>
                          </v-col>
                          <v-col cols="8">
                            <div class="font-weight-medium text-center">{{ menu.title }}</div>
                            <div class="text-caption text--secondary text-center">
                              <strong>{{ menu.time }}</strong>
                              <span v-if="menu.description"> - {{ menu.description }}</span>
                            </div>
                          </v-col>
                          <v-col cols="2" class="text-right">
                            <v-chip
                                x-small
                                :color="menu.timeMeal === 'Déjeuner' ? '#ED7F10' : '#C71585'"
                                text-color="white"
                                class="justify-center"
                                style="min-width: 35px;"
                            >
                              {{ menu.timeMeal === 'Déjeuner' ? 'Déj' : 'Dîn' }}
                            </v-chip>
                          </v-col>
                        </v-row>
                        <v-divider v-if="menuIndex < dayData.menus.length - 1" class="my-2"></v-divider>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </v-col>
            </v-row>

            <!-- Mobile Menu Details Dialog -->
            <v-dialog
                v-model="mobileMenuDetailsDialog"
                max-width="500"
            >
              <v-card v-if="selectedMenu">
                <v-card-title class="headline">
                  {{ selectedMenu.title }}
                  <v-spacer></v-spacer>
                  <v-btn
                      icon
                      @click="mobileMenuDetailsDialog = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <v-list>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon color="#ED7F10">mdi-clock-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Heure & Service</v-list-item-title>
                        <v-list-item-subtitle>
                          {{ selectedMenu.time }} - {{ selectedMenu.timeMeal }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-if="selectedMenu.description">
                      <v-list-item-icon>
                        <v-icon>mdi-text</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Description</v-list-item-title>
                        <v-list-item-subtitle>
                          {{ selectedMenu.description }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-if="selectedMenu.price">
                      <v-list-item-icon>
                        <v-icon>mdi-cash</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Prix</v-list-item-title>
                        <v-list-item-subtitle>
                          {{ selectedMenu.price }} FCFA
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-if="selectedMenu.restaurateur">
                      <v-list-item-icon>
                        <v-icon>mdi-silverware-fork-knife</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Restaurateur</v-list-item-title>
                        <v-list-item-subtitle>
                          {{ selectedMenu.restaurateur }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";
import * as XLSX from 'xlsx';
import * as string from "core-js";
import Vue from "vue";
import MenuBulkImport from './MenuBulkImport.vue';

Vue.filter('kb', val => {
  return Math.floor(val / 1024);
});

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "Menus",
  components: {
    MenuBulkImport
  },
  data: function () {
    return {
      isLoadingMenus: true,
      sigleRestaurateur: "",
      restaurateurs: JSON.parse(sessionStorage.getItem("restaurateurs")),
      bHideRestaurateur: false,
      isMobile: isMobileDevice(),
      bDisplayOK_Corinne: false,
      bDisplayOK_PointFocal: false,
      bDisplayOK_Restaurateur: false,
      radiosFree: 'agent_account',
      horaires: "",
      freeOrNot: false,
      disableMainBtn: false,
      dateMinDP: moment().add(0, 'days').format("YYYY-MM-DD").toString(),
      fileBtn: true,
      drag_over: false,
      over_others: false,
      files: [],
      bQuitAlert: false,
      modal: false,
      menu: false,
      e6: 1,
      message: "",
      items: [],
      lastHighlitedRow: null,
      isdisabledDate: true,
      isdisabledTime: true,
      menu1: null,
      menu2: null,
      type: null,
      typeDlg: null,
      elapse: null,
      elapseDlg: null,
      loading: false,
      loading2: false,
      modal2: false,
      modal3: false,
      toObject: [],
      products: [],
      fullProducts: [[]],
      timeMeal: [],
      editedItem: {
        menuName: "",
        timeMeal: [],
        planningDates: [],
        serviceDate: "",
        startTime: "",
        detailsMenu: "",
        productName: "",
        productPrice: process.env.VUE_APP_APP_PRODUCT_PRICE,
        free4Agent: false,
        productDescription: "",
        restaurateur: ""
      },
      editedItemModif: {
        id: "",
        menuName: "",
        timeMeal: [],
        planningDates: [],
        serviceDate: "",
        startTime: "",
        detailsMenu: "",
        productName: "",
        productPrice: process.env.VUE_APP_APP_PRODUCT_PRICE,
        free4Agent: false,
        productDescription: "",
        restaurateur: ""
      },
      tab: null,
      dialog: false,
      alert: false,
      alertDlg: false,
      fullPage: false,
      text: "",
      textDlg: "",
      color: "",
      file: "",
      editedIndex: -1,
      errors: [],
      errorsDlg: [],
      excelData: [],
      arrayAbs: [],

      // Compteurs pour les heures décalées par date et type de repas
      menuTimeCounters: {}, // Structure: { "2024-01-15": { "Déjeuner": 0, "Dîner": 0 } }

      // Vuetify Calendar specific data
      focus: '',
      calendarType: 'month',
      calendarEvents: [],
      filteredCalendarEvents: [],
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      calendarSearchQuery: '',

      // Mobile view specific data
      mobileViewType: 'list',
      selectedDateFilter: 0,
      searchQuery: '',
      mobileMenuData: [],
      filteredMobileMenuData: [],
      expansionPanel: null,
      mobileMenuDetailsDialog: false,
      selectedMenu: null
    }
  },

  created() {
    moment.locale('fr');
    this.isAdmin()
    this.isPointFocal()
    this.isRestaurateur()
    this.loadProducts()
  },

  computed: {
    FormIsValidAdd() {
      var bResul = true;

      bResul = !this.isEmpty(this.editedItem.productName)
      if (bResul === false) {
        return bResul
      }
      bResul = !this.isEmpty(this.editedItem.productPrice)
      if (bResul === false) {
        return bResul
      }

      let name = this.recupRestaurateur();

      let b1 = this.isEmpty(name)
      let b2 = this.bHideRestaurateur
      let b3 = this.isEmpty(this.editedItem.restaurateur)

      if (((b1 || !b2) && (!b1 || b3))) {
        return false
      }

      return bResul;
    },
    FormIsValidModif() {
      var bResul = true;

      bResul = (this.editedItemModif.productName !== "")
      if (bResul === false) {
        return bResul
      }
      bResul = (this.editedItemModif.productPrice !== "")
      if (bResul === false) {
        return bResul
      }

      return bResul;
    },

    FormIsValidSupp() {
      var bResul = true;

      bResul = (this.editedItemModif.productName !== "")
      if (bResul === false) {
        return bResul
      }

      return bResul;
    }
  },

  methods: {
    // Méthode pour obtenir le mois et l'année actuels
    getCurrentMonthYear() {
      if (!this.focus) {
        // Si pas de focus, utiliser la date actuelle
        return moment().format('MMMM YYYY').toUpperCase();
      }
      // Utiliser le focus actuel du calendrier
      return moment(this.focus).format('MMMM YYYY').toUpperCase();
    },
    
    // Méthode pour réinitialiser les compteurs
    resetMenuTimeCounters() {
      this.menuTimeCounters = {};
      // console.log('🔄 Compteurs réinitialisés');
    },

    // Méthode pour obtenir l'heure décalée
    getStaggeredTime(date, mealType) {
      // Handle both DD-MM-YYYY and YYYY-MM-DD formats
      let dateKey;
      if (date.match(/^\d{4}-\d{2}-\d{2}$/)) {
        // Already in YYYY-MM-DD format
        dateKey = date;
      } else if (date.match(/^\d{2}-\d{2}-\d{4}$/)) {
        // DD-MM-YYYY format
        dateKey = moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD');
      } else {
        console.warn('Date format not recognized:', date);
        dateKey = moment(date).format('YYYY-MM-DD');
      }

      // Normaliser le type de repas (gérer "Diner" sans accent)
      const normalizedMealType = (mealType === "Déjeuner") ? "Déjeuner" : "Diner";

      // Initialiser les compteurs pour cette date si nécessaire
      if (!this.menuTimeCounters[dateKey]) {
        this.menuTimeCounters[dateKey] = {
          "Déjeuner": 0,
          "Diner": 0
        };
        //console.log(`📅 Nouvelle date: ${dateKey}`);
      }

      // DÉJEUNERS à 13h, DÎNERS à 20h
      const baseHour = (normalizedMealType === "Déjeuner") ? 13 : 20;

      // Calculer l'heure avec décalage de 20 minutes
      const currentCount = this.menuTimeCounters[dateKey][normalizedMealType];
      const totalMinutes = (baseHour * 60) + (currentCount * 20);
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      // Incrémenter le compteur pour le prochain menu
      this.menuTimeCounters[dateKey][normalizedMealType]++;

      // Debug pour vérifier
      const timeStr = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
      // console.log(`🍽️ ${normalizedMealType} #${currentCount + 1} → ${timeStr} (${dateKey})`);

      // Retourner l'heure formatée
      return `${timeStr}:00`;
    },

    // Vuetify Calendar Methods (FORCER Déjeuner avant Dîner SANS EXCEPTION)
    convertItemsToCalendarEvents() {
      const events = this.items.map(item => {
        const timeMeal = item.classes === 'yellow' ? 'Déjeuner' : 'Dîner'
        const fullProduct = this.fullProducts.find(p => p.name === item.title)

        const startMoment = moment(item.startDate)

        // Validation de la date
        if (!startMoment.isValid()) {
          return null
        }

        return {
          name: item.title,
          start: startMoment.format('YYYY-MM-DD HH:mm'), // Format string pour v-calendar
          end: startMoment.format('YYYY-MM-DD HH:mm'),
          color: item.classes === 'yellow' ? '#ED7F10' : '#C71585',
          allDay: false, // Afficher les heures
          timeMeal: timeMeal,
          description: fullProduct?.description || '',
          price: fullProduct?.price,
          restaurateur: fullProduct?.originProduct,
          dateKey: startMoment.format('YYYY-MM-DD'),
          isLunch: timeMeal === 'Déjeuner',
          time: startMoment.format('HH:mm'),
          sortTime: startMoment.valueOf()
        }
      }).filter(event => event !== null)

      // Grouper par date puis trier par heure dans chaque catégorie
      const eventsByDate = {}
      events.forEach(event => {
        if (!eventsByDate[event.dateKey]) {
          eventsByDate[event.dateKey] = { lunch: [], dinner: [] }
        }
        if (event.isLunch) {
          eventsByDate[event.dateKey].lunch.push(event)
        } else {
          eventsByDate[event.dateKey].dinner.push(event)
        }
      })

      // Reconstruire la liste : pour chaque date, déjeuners triés par heure puis dîners triés par heure
      const sortedEvents = []
      Object.keys(eventsByDate).sort().forEach(date => {
        // Trier les déjeuners par heure
        const sortedLunch = eventsByDate[date].lunch.sort((a, b) => a.sortTime - b.sortTime)
        // Trier les dîners par heure
        const sortedDinner = eventsByDate[date].dinner.sort((a, b) => a.sortTime - b.sortTime)

        // D'ABORD tous les déjeuners (triés par heure)
        sortedEvents.push(...sortedLunch)
        // PUIS tous les dîners (triés par heure)
        sortedEvents.push(...sortedDinner)
      })

      this.calendarEvents = sortedEvents
      this.filteredCalendarEvents = [...this.calendarEvents]
    },

    getEventColor(event) {
      return event.color
    },

    showEventDetails({ nativeEvent, event }) {
      if (!event || !nativeEvent) {
        return
      }

      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },

    viewDay({ date }) {
      this.focus = date
      this.calendarType = 'day'
    },

    setToday() {
      this.focus = ''
    },

    updateRange({ start, end }) {
      // Calendar range changed silently
    },

    formatDate(date) {
      // Gérer les cas où date peut être une string, un objet Date, ou undefined
      if (!date) {
        return 'Date non disponible';
      }

      let momentDate;
      if (typeof date === 'string') {
        momentDate = moment(date);
      } else if (date instanceof Date) {
        momentDate = moment(date);
      } else {
        return 'Format de date invalide';
      }

      if (!momentDate.isValid()) {
        return 'Date invalide';
      }

      return momentDate.format('dddd DD MMMM YYYY');
    },

    filterCalendarEvents() {
      if (!this.calendarSearchQuery) {
        this.filteredCalendarEvents = [...this.calendarEvents]
        return
      }

      const query = this.calendarSearchQuery.toLowerCase()
      const filtered = this.calendarEvents.filter(event =>
          event.name.toLowerCase().includes(query) ||
          (event.description && event.description.toLowerCase().includes(query))
      )

      // Regrouper et réordonner avec tri par heure
      const eventsByDate = {}
      filtered.forEach(event => {
        if (!eventsByDate[event.dateKey]) {
          eventsByDate[event.dateKey] = { lunch: [], dinner: [] }
        }
        if (event.isLunch) {
          eventsByDate[event.dateKey].lunch.push(event)
        } else {
          eventsByDate[event.dateKey].dinner.push(event)
        }
      })

      // Reconstruire : déjeuners puis dîners pour chaque date, triés par heure
      const sortedFiltered = []
      Object.keys(eventsByDate).sort().forEach(date => {
        // Trier par heure dans chaque catégorie
        const sortedLunch = eventsByDate[date].lunch.sort((a, b) => a.sortTime - b.sortTime)
        const sortedDinner = eventsByDate[date].dinner.sort((a, b) => a.sortTime - b.sortTime)

        sortedFiltered.push(...sortedLunch)
        sortedFiltered.push(...sortedDinner)
      })

      this.filteredCalendarEvents = sortedFiltered
    },

    // Mobile view methods
    setDateFilter(filter) {
      moment.locale('fr');
      const today = moment();
      let startDate, endDate;

      switch (filter) {
        case 'today':
          startDate = today.clone();
          endDate = today.clone();
          break;
        case 'week':
          startDate = today.clone().startOf('week');
          endDate = today.clone().endOf('week');
          break;
        case 'month':
          startDate = today.clone().startOf('month');
          endDate = today.clone().endOf('month');
          break;
      }

      this.filterMobileMenusByDateRange(startDate, endDate);
    },

    filterMobileMenusByDateRange(startDate, endDate) {
      this.filteredMobileMenuData = this.mobileMenuData.filter(dayData => {
        const dayDate = moment(dayData.date);
        return dayDate.isBetween(startDate, endDate, 'day', '[]');
      });
    },

    filterMobileMenus() {
      if (!this.searchQuery) {
        this.filteredMobileMenuData = [...this.mobileMenuData];
        return;
      }

      const query = this.searchQuery.toLowerCase();
      this.filteredMobileMenuData = this.mobileMenuData.map(dayData => {
        // Séparer en déjeuners et dîners
        const lunchMenus = []
        const dinnerMenus = []

        dayData.menus.forEach(menu => {
          const matchesSearch = menu.title.toLowerCase().includes(query) ||
              (menu.description && menu.description.toLowerCase().includes(query))

          if (matchesSearch) {
            if (menu.timeMeal === 'Déjeuner') {
              lunchMenus.push(menu)
            } else {
              dinnerMenus.push(menu)
            }
          }
        })

        // Trier par heure dans chaque catégorie avant de recombiner
        const sortedLunch = lunchMenus.sort((a, b) =>
            moment(a.startDate).valueOf() - moment(b.startDate).valueOf()
        );
        const sortedDinner = dinnerMenus.sort((a, b) =>
            moment(a.startDate).valueOf() - moment(b.startDate).valueOf()
        );

        // Recombiner : TOUS les déjeuners puis TOUS les dîners, triés par heure
        const orderedMenus = [...sortedLunch, ...sortedDinner]

        return {
          ...dayData,
          menus: orderedMenus
        };
      }).filter(dayData => dayData.menus.length > 0);
    },

    formatDateHeader(dateStr) {
      const date = moment(dateStr);
      date.locale('fr');
      const today = moment();
      const tomorrow = moment().add(1, 'day');

      if (date.isSame(today, 'day')) {
        return `Aujourd'hui ${date.format('DD/MM/YYYY')}`;
      } else if (date.isSame(tomorrow, 'day')) {
        return `Demain ${date.format('DD/MM/YYYY')}`;
      } else {
        return date.format('dddd DD/MM/YYYY');
      }
    },

    showMobileMenuDetails(menu) {
      const fullProduct = this.fullProducts.find(p => p.name === menu.title);

      this.selectedMenu = {
        ...menu,
        description: fullProduct?.description || menu.description,
        price: fullProduct?.price,
        restaurateur: fullProduct?.originProduct,
        time: menu.time // Inclure l'heure
      };

      this.mobileMenuDetailsDialog = true;
    },

    prepareMobileMenuData() {
      const menusByDate = {};
      moment.locale('fr');

      this.items.forEach(item => {
        const dateKey = moment(item.startDate).format('YYYY-MM-DD');

        if (!menusByDate[dateKey]) {
          menusByDate[dateKey] = { lunch: [], dinner: [] };
        }

        const timeMeal = item.classes === 'yellow' ? 'Déjeuner' : 'Dîner';
        const fullProduct = this.fullProducts.find(p => p.name === item.title);

        const menuData = {
          id: item.id,
          title: item.title,
          timeMeal: timeMeal,
          description: fullProduct?.description || '',
          time: moment(item.startDate).format('HH:mm'), // Afficher l'heure réelle
          startDate: item.startDate // Garder la date complète pour le tri
        };

        // Séparer strictement déjeuners et dîners
        if (timeMeal === 'Déjeuner') {
          menusByDate[dateKey].lunch.push(menuData)
        } else {
          menusByDate[dateKey].dinner.push(menuData)
        }
      });

      this.mobileMenuData = Object.keys(menusByDate)
          .map(date => {
            // Trier les menus par heure dans chaque catégorie
            const sortedLunch = menusByDate[date].lunch.sort((a, b) =>
                moment(a.startDate).valueOf() - moment(b.startDate).valueOf()
            );
            const sortedDinner = menusByDate[date].dinner.sort((a, b) =>
                moment(a.startDate).valueOf() - moment(b.startDate).valueOf()
            );

            // FORCER l'ordre : TOUS les déjeuners puis TOUS les dîners
            const allMenus = [...sortedLunch, ...sortedDinner];

            return {
              date: date,
              menus: allMenus
            }
          })
          .sort((a, b) => a.date.localeCompare(b.date));

      this.filteredMobileMenuData = [...this.mobileMenuData];
      this.setDateFilter('today');
    },

    // Update loadProducts method
    async loadProducts() {
      try {
        this.isLoadingMenus = true;

        // Réinitialiser les compteurs d'heures AVANT tout traitement
        this.resetMenuTimeCounters();

        const response = await apiClient.get(
            `${this.$store.getters.user.baseUrl}/product/all/` + sessionStorage.getItem("userId")
        );

        this.items = []
        sessionStorage.setItem("Products", null)
        let datas = response.data.datas;
        this.fullProducts = datas;
        this.products = [];
        let i = 0;

        // Trier les produits par date ET par type de repas pour assurer l'ordre correct
        const sortedDatas = datas.sort((a, b) => {
          // D'abord par date
          const datesA = a.listDates ? a.listDates.split(',').map(d => d.trim()).sort() : [];
          const datesB = b.listDates ? b.listDates.split(',').map(d => d.trim()).sort() : [];

          if (datesA[0] !== datesB[0]) {
            return datesA[0] < datesB[0] ? -1 : 1;
          }

          // Puis par type de repas (Déjeuner avant Diner)
          const timeMealA = a.timeMeal || '';
          const timeMealB = b.timeMeal || '';

          const hasLunchA = timeMealA.includes('Déjeuner');
          const hasLunchB = timeMealB.includes('Déjeuner');

          if (hasLunchA && !hasLunchB) return -1;
          if (!hasLunchA && hasLunchB) return 1;

          return 0;
        });

        // console.log('Traitement de', sortedDatas.length, 'produits triés');

        sortedDatas.forEach(item => {
          // Vérification simple des données au lieu de validateProductData
          if (!item || !item.listDates || !item.timeMeal ||
              item.listDates.trim() === '' || item.timeMeal.trim() === '') {
            console.log('❌ Produit ignoré (données invalides):', item.name);
            return;
          }

          if (this.bDisplayOK_Restaurateur) {
            let s1 = item.originProduct.toLowerCase();
            let s2 = this.sigleRestaurateur.toLowerCase()
            if (s1.localeCompare(s2) === 0) {
              this.products.push(item.name);
              this.AddItemCalendar(item);
            }
          } else {
            this.products.push(item.name);
            this.AddItemCalendar(item);
          }
          i++;
        });

        // console.log('Items créés:', this.items.length);
        // console.log('État final des compteurs:', this.menuTimeCounters);

        this.products.sort()
        sessionStorage.setItem("Products", JSON.stringify(this.products))

        if (this.isMobile) {
          this.prepareMobileMenuData();
        } else {
          this.$nextTick(() => {
            this.convertItemsToCalendarEvents();
          });
        }

      } catch (error) {
        console.error("Erreur lors du chargement des menus:", error);
        this.showAlert("Erreur lors du chargement des menus", "error");
      } finally {
        this.isLoadingMenus = false;
      }
    },

    deleteDinerM() {
      for (var i = 0; i < this.editedItemModif.timeMeal.length; i++) {
        if (this.editedItemModif.timeMeal[i] === "Diner") {
          this.editedItemModif.timeMeal.splice(i, 1);
        }
      }
    },
    deleteDejeunerM() {
      for (var i = 0; i < this.editedItemModif.timeMeal.length; i++) {
        if (this.editedItemModif.timeMeal[i] === "Déjeuner") {
          this.editedItemModif.timeMeal.splice(i, 1);
        }
      }
    },
    deleteDinerA() {
      for (var i = 0; i < this.editedItem.timeMeal.length; i++) {
        if (this.editedItem.timeMeal[i] === "Diner") {
          this.editedItem.timeMeal.splice(i, 1);
        }
      }
    },
    deleteDejeunerA() {
      for (var i = 0; i < this.editedItem.timeMeal.length; i++) {
        if (this.editedItem.timeMeal[i] === "Déjeuner") {
          this.editedItem.timeMeal.splice(i, 1);
        }
      }
    },
    isAdmin() {
      this.bDisplayOK_Corinne = (sessionStorage.getItem("userId").toLowerCase() === "admin")
    },
    isPointFocal() {
      this.bDisplayOK_PointFocal = sessionStorage.getItem('userRole').toLowerCase() === "POINT FOCAL RESTO".toLowerCase() ||
          sessionStorage.getItem('userRole').toLowerCase() === "CHEF DE POSTE".toLowerCase()
    },
    isRestaurateur() {
      this.bDisplayOK_Restaurateur = sessionStorage.getItem('userRole').toLowerCase() === "RESTAURATEUR".toLowerCase()

      if (this.bDisplayOK_Restaurateur) {
        apiClient
            .get(
                `${this.$store.getters.user.baseUrl}/account/userInfos/` + sessionStorage.getItem("userId") + "/" + sessionStorage.getItem("userId")
            )
            .then(response => {
              let newObj = response.data.data;
              this.sigleRestaurateur = newObj.accountLastname
            })
            .catch(error => {
              console.log("Menus")
            });
      }
    },
    dragEnter(e) {
      if (e.target === this.$refs.others)
        this.over_others = true
      else
        this.drag_over = true
    },
    dragOver(e) {
      if (e.target === this.$refs.others) this.over_others = true
      else this.drag_over = true
    },
    dragLeave(e) {
      if (e.target === this.$refs.others) this.over_others = false
      else if (!this.over_others) this.drag_over = false
    },
    isAlphaNumeric(str) {
      var ch;

      for (var i = 0; i < string.length; i++) {
        ch = string.charAt(i);
        if (!(ch >= '0' && ch <= '9') &&
            !(ch >= 'A' && ch <= 'Z') &&
            !(ch >= 'a' && ch <= 'z'))
          return false;
      }
      return true;
    },
    isInt(value) {
      var x = parseFloat(value);
      return !isNaN(value) && (x | 0) === x;
    },
    IsValidCreate() {
      var bResul = true;

      bResul = this.isAlphaNumeric(this.editedItem.productName)
      if (bResul === false) {
        this.textDlg = "Le nom du menu doit être un chaine de caractères.";
        this.showAlertDlg('warning')
        return bResul
      }
      bResul = this.isInt(this.editedItem.productPrice)
      if (bResul === false) {
        this.textDlg = "Le prix du menu doit être un entier.";
        this.showAlertDlg('warning')
        return bResul
      }
      bResul = this.isAlphaNumeric(this.editedItem.productDescription)
      if (bResul === false) {
        this.textDlg = "Le nom du menu doit être un chaine de caractères.";
        this.showAlertDlg('warning')
        return bResul
      }

      return bResul;
    },
    IsValidUpdate() {
      var bResul = true;

      bResul = this.isAlphaNumeric(this.editedItemModif.productName)
      if (bResul === false) {
        this.textDlg = "Le nom du menu doit être un chaine de caractères.";
        this.showAlertDlg('warning')
        return bResul
      }
      bResul = this.isInt(this.editedItemModif.productPrice)
      if (bResul === false) {
        this.textDlg = "Le prix du menu doit être un entier.";
        this.showAlertDlg('warning')
        return bResul
      }
      bResul = this.isAlphaNumeric(this.editedItemModif.productDescription)
      if (bResul === false) {
        this.textDlg = "Le nom du menu doit être un chaine de caractères.";
        this.showAlertDlg('warning')
        return bResul
      }

      return bResul;
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    AddItemCalendar(product) {
      var ind = 0

      // Vérifications robustes
      if (!product.listDates || product.listDates.trim() === '') {
        return;
      }

      if (!product.timeMeal || product.timeMeal.trim() === '') {
        return;
      }

      var listplanning = product.listDates.split(',').filter(date => date.trim() !== '')
      var listTime = product.timeMeal.split(',').filter(time => time.trim() !== '')

      // POUR CHAQUE DATE, traiter d'abord TOUS les déjeuners, puis TOUS les dîners
      listplanning.forEach((itemp) => {
        const cleanDate = itemp.trim()
        if (!cleanDate) {
          return;
        }

        // Basic date validation - let moment handle format detection
        if (!cleanDate || cleanDate.length < 8) {
          return
        }

        // Séparer les types de repas
        const dejeuners = listTime.filter(t => t.trim() === "Déjeuner");
        const diners = listTime.filter(t => t.trim() === "Diner");

        // TRAITER D'ABORD TOUS LES DÉJEUNERS pour cette date
        dejeuners.forEach((itemt) => {
          const cleanTime = itemt.trim()
          const classe = "yellow"

          const hour = this.getStaggeredTime(cleanDate, cleanTime)
          const fullDateTime = cleanDate + " " + hour
          const momentDateTime = moment(fullDateTime, "YYYY-MM-DD HH:mm:ss")

          if (!momentDateTime.isValid()) {
            return
          }

          const formattedDateTime = momentDateTime.format("YYYY-MM-DD HH:mm:ss")

          this.items.push({
            startDate: formattedDateTime,
            endDate: formattedDateTime,
            title: product.name,
            id: product.id + "_" + (++ind),
            classes: classe,
          })
        });

        // PUIS TRAITER TOUS LES DÎNERS pour cette date
        diners.forEach((itemt) => {
          const cleanTime = itemt.trim()
          const classe = "orange"

          const hour = this.getStaggeredTime(cleanDate, cleanTime)
          const fullDateTime = cleanDate + " " + hour
          const momentDateTime = moment(fullDateTime, "YYYY-MM-DD HH:mm:ss")

          if (!momentDateTime.isValid()) {
            return
          }

          const formattedDateTime = momentDateTime.format("YYYY-MM-DD HH:mm:ss")

          this.items.push({
            startDate: formattedDateTime,
            endDate: formattedDateTime,
            title: product.name,
            id: product.id + "_" + (++ind),
            classes: classe,
          })
        });
      })
    },
    init() {
      this.tab = "tab-1";
      this.file = "";
      this.files = [];
      this.fileBtn = true;
      this.drag_over = false;
      this.editedItem.productName = "";
      this.editedItem.productPrice = process.env.VUE_APP_APP_PRODUCT_PRICE;
      this.editedItem.planningDates = [];
      this.editedItem.timeMeal = [];
      this.editedItem.productDescription = "";
      this.editedItem.restaurateur = "";
      this.editedItemModif.id = "";
      this.editedItemModif.productName = "";
      this.editedItemModif.productPrice = process.env.VUE_APP_APP_PRODUCT_PRICE;
      this.editedItemModif.planningDates = [];
      this.editedItemModif.timeMeal = [];
      this.editedItemModif.productDescription = "";
      this.editedItemModif.free4Agent = "";
      this.editedItemModif.restaurateur = "";
      this.radiosFree = 'agent_account'
    },
    recupRestaurateur() {
      let name = ""

      try {
        this.restaurateurs.forEach(resto => {
          if (this.editedItem.productName.includes("# " + resto) === true) {
            name = resto;
            throw new Error("Name found.")
          }
        });
      } catch (error) {
        return name;
      }

      return name;
    },
    ifRestaurateurPresent(name) {
      try {
        this.restaurateurs.forEach(resto => {
          if (!this.isEmpty(name.toLowerCase()) && name.toLowerCase().includes("# " + resto.toLowerCase()) === true) {
            throw new Error("Name found.")
          }
        });
      } catch (error) {
        return true;
      }

      return false;
    },
    uploadProduct() {
      this.bHideRestaurateur = false;
      let bOneTime = true;
      this.editedItem.restaurateur = ""

      this.restaurateurs.forEach(resto => {
        if ((this.editedItem.productName.includes("# " + resto) === true) && bOneTime) {
          this.editedItem.restaurateur = resto;
          this.bHideRestaurateur = true;
          bOneTime = false;
        }
      });

      this.fullProducts.forEach(item => {
        if (item.name === this.editedItemModif.productName) {
          this.editedItemModif.id = item.id;
          this.editedItemModif.productPrice = item.price;
          this.editedItemModif.planningDates = this.isEmpty(item.listDates) ? [] : item.listDates.split(',');
          this.editedItemModif.timeMeal = this.isEmpty(item.timeMeal) ? [] : item.timeMeal.split(',');
          this.editedItemModif.productDescription = item.description;
          this.editedItemModif.restaurateur = item.originProduct;
          this.radiosFree = (item.free4Agent === true) ? 'tsa_account' : 'agent_account';
        }
      });

      this.FormIsValidAdd;
    },
    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },
    onCancel() {
      this.loading = false
    },
    async refresh() {
      try {
        this.isLoadingMenus = true;

        // Réinitialiser les compteurs avant le rechargement
        this.resetMenuTimeCounters();

        await this.loadProducts();
        this.text = "Menus actualisés avec succès";
        this.showAlert("info");
      } catch (error) {
        console.error("Erreur lors du rafraîchissement:", error);
        this.text = "Erreur lors du rafraîchissement";
        this.showAlert("error");
      }
    },
    datefull(val) {
      if (!val) {
        return
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    convertDate(val) {
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY");
    },
    close() {
      this.radiosFree = 'agent_account'
      this.dialog = false;
      this.file = "";
      this.files = [];
      this.fileBtn = true;
      this.drag_over = false;
    },
    AlertColorDlg(typeDlg) {
      return typeDlg === "info" ? "#4CAF50" : "#F44336";
    },
    showAlertDlg(type) {
      this.typeDlg = type

      let timer = this.showAlertDlg.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlertDlg.timer = setTimeout(() => {
        this.typeDlg = null
      }, 20000)

      this.elapseDlg = 1
      let t = this.showAlertDlg.t
      if (t) {
        clearInterval(t)
      }

      this.showAlertDlg.t = setInterval(() => {
        if (this.elapseDlg === 3) {
          this.elapseDlg = 0
          clearInterval(this.showAlertDlg.t)
        } else {
          this.elapseDlg++
        }
      }, 5000)
    },
    dismissible_close_dlg() {
      this.elapseDlg = 3
      clearTimeout(this.showAlertDlg.timer)
      clearInterval(this.showAlertDlg.t)
      this.typeDlg = null
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    closeAlert() {
      this.radiosFree = 'agent_account'
      this.alert = false
      this.text = ""
      this.errors = []
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    onFilePicked(e) {
      const files = e.target.files;
      this.file = this.$refs.fileInput.files[0];
      if (!files.length) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.text = "Le format du fichier est incorrecte.\nMerci de choisir un format xls ou xlsx";
        this.showAlert('warning');
        return false;
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0];
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {defval: "", skipHidden: true});
          const excellist = [];
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          }
          this.total = excellist
              .map(item => item.montant)
              .reduce((prev, curr) => prev + curr, 0);
          this.excelData = excellist.map(function (item) {
            return Object.values(item);
          })

          this.fileBtn = false;
        } catch (e) {
          this.text = "Erreur de lecture du fichier !";
          this.showAlert('warning')
          return false;
        }
      }
      fileReader.readAsBinaryString(files[0]);
      const input = document.getElementById("upload");
      input.value = "";
    },
    modifier() {
      if (this.IsValidUpdate() === false)
        return;

      this.loading = true
      const dataToSave = {
        id: this.editedItemModif.id,
        name: this.editedItemModif.productName,
        price: this.editedItemModif.productPrice,
        description: this.editedItemModif.productDescription,
        listDates: this.editedItemModif.planningDates.toString(),
        timeMeal: this.editedItemModif.timeMeal.toString(),
        free4Agent: this.radiosFree !== 'agent_account',
        originProduct: this.editedItemModif.restaurateur
      };
      apiClient
          .post(`${this.$store.getters.user.baseUrl}/product/update/` + this.editedItemModif.id + "/" + sessionStorage.getItem("userId"),
              dataToSave
          )
          .then(res => {
            this.dialog = false;
            this.loading = false
            if (res.data.status === 200) {
              this.color = "#009688"
              this.text = res.data.message
              this.init();
              this.showAlert('info')
              this.refresh()
            } else {
              this.color = "#F44336"
              this.alert = true
              this.text = res.data.message;
              this.init();
              this.showAlert('warning')
            }
          })
          .catch(error => {
            this.dialog = false;
            this.alert = true
            this.text = error;
            this.loading = false
            this.color = "#F44336"
            this.showAlert('warning')
          });
    },
    supprimer() {
      let message = {
        title: 'Fenêtre de confirmation',
        body: 'Confirmez la suppression du menu.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            this.loading = true
            apiClient
                .delete(
                    `${this.$store.getters.user.baseUrl}/product/delete/` + this.editedItemModif.id + "/" + sessionStorage.getItem("userId")
                )
                .then(res => {
                  dialog.close();
                  this.dialog = false;
                  this.loading = false
                  if (res.data.status === 200) {
                    this.color = "#009688"
                    this.text = res.data.message
                    this.init();
                    this.showAlert('info')
                    this.refresh()
                  } else {
                    this.color = "#F44336"
                    this.alert = true
                    this.text = res.data.message;
                    this.init();
                    this.showAlert('warning')
                  }
                })
                .catch(error => {
                  dialog.close();
                  this.dialog = false;
                  this.alert = true
                  this.text = error;
                  this.loading = false
                  this.color = "#F44336"
                  this.showAlert('warning')
                });
          })
          .catch(() => {

          });
    },
    ajouter() {
      if (this.IsValidCreate() === false)
        return;

      this.loading = true
      const dataToSave = {
        name: this.editedItem.productName,
        price: this.editedItem.productPrice,
        description: this.editedItem.productDescription,
        listDates: this.editedItem.planningDates.toString(),
        timeMeal: this.editedItem.timeMeal.toString(),
        free4Agent: this.radiosFree !== 'agent_account',
        originProduct: this.editedItem.restaurateur
      };
      apiClient
          .post(`${this.$store.getters.user.baseUrl}/product/create/` + sessionStorage.getItem("userId"),
              dataToSave
          )
          .then(res => {
            this.dialog = false;
            this.loading = false
            if (res.data.status === 200) {
              this.color = "#009688"
              this.text = res.data.message
              this.radiosFree = 'agent_account'
              this.init();
              this.showAlert('info')
              this.refresh()
            } else {
              this.color = "#F44336"
              this.alert = true
              this.text = res.data.message;
              this.init();
              this.showAlert('warning')
            }
          })
          .catch(error => {
            this.dialog = false;
            this.alert = true
            this.text = error;
            this.loading = false
            this.color = "#F44336"
            this.showAlert('warning')
          });
    },
    formatDateUs(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${year}-${month}-${day}`
    },
    importFileToHandsonTableMenus() {
      let vm = this;
      vm.loading = true
      vm.dialog = false;
      this.file = ""
      let dataTosave = [];

      let sdates, stimes, sdate
      let stringDates = ""
      let stringTimes = ""
      let arrayDates = []
      let arrayTimes = []
      let originProduct = ""

      let productName = "";
      let productDescription = "";

      String.prototype.capitalize = function (allWords) {
        return (allWords) ?
            this.split(' ').map(word => word.capitalize()).join(' ') :
            this.charAt(0).toUpperCase() + this.slice(1);
      }

      for (let i = 0; i < this.excelData.length; i++) {
        productName = this.excelData[i][0];
        productDescription = this.excelData[i][1];
        sdates = this.excelData[i][2];
        stimes = this.excelData[i][3];
        originProduct = this.excelData[i][4];

        if (!(this.isAlphaNumeric(productName) && this.isAlphaNumeric(productDescription) && !this.isEmpty(sdates) && !this.isEmpty(stimes))) {
          if (this.isAlphaNumeric(productName) === false) {
            this.text = "Erreur -> Ligne " + (i + 2) + " -> Le nom du menu doit être un chaine de caractères.";
            this.showAlert('warning')
            vm.loading = false
            return
          }

          if (this.isAlphaNumeric(productDescription) === false) {
            this.text = "Erreur -> Ligne " + (i + 2) + " -> Le nom du menu doit être un chaine de caractères.";
            this.showAlert('warning')
            vm.loading = false
            return
          }

          if (this.isEmpty(sdates)) {
            this.text = "Erreur -> Ligne " + (i + 2) + " -> Il faut au moins une date de planning sous la forme (jj/mm/aaaa) avec la virgule comme séparateur - cf modèle.";
            this.showAlert('warning')
            vm.loading = false
            return
          }

          if (this.isEmpty(stimes)) {
            this.text = "Erreur -> Ligne " + (i + 2) + " -> Il faut au moins un moment pour le service du jour choisi donc soit Déjeuner et/ou Dîner avec la virgule comme séparateur - cf modèle.";
            this.showAlert('warning')
            vm.loading = false
            return
          }

          if (this.ifRestaurateurPresent(originProduct)) {
            this.text = "Erreur -> Ligne " + (i + 2) + " -> Il faut obligatoirement un restaurateur existant pour chaque produit - cf modèle.";
            this.showAlert('warning')
            vm.loading = false
            return
          }
        }

        stringDates = ""
        sdates = sdates.trim()
        if ((sdates.length !== 0) && (sdates[sdates.length - 1] === ',')) {
          sdates = sdates.slice(0, sdates.length - 1) + sdates.slice(sdates.length, sdates.length)
        }

        arrayDates = sdates.split(',')
        for (let j = 0; j < arrayDates.length; j++) {
          arrayDates[j] = arrayDates[j].trim()

          sdate = moment(arrayDates[j], "DD/MM/YYYY").format("YYYY-MM-DD")

          if (sdate === "Invalid date") {
            sdate = moment(arrayDates[j], "DD-MM-YYYY").format("YYYY-MM-DD")
            if (sdate === "Invalid date") {
              sdate = moment(arrayDates[j], "DD-MM-YY").format("YYYY-MM-DD")
              if (sdate === "Invalid date") {
                sdate = moment(arrayDates[j], "DD/MM/YY").format("YYYY-MM-DD")
                if (sdate === "Invalid date") {
                  this.text = "Date & Heure invalide -> Ligne " + (i + 2) +
                      ".\nLes dates doivent être au format texte 'jj/mm/aaaa' - (cf modèle)."

                  this.showAlert('warning')
                  vm.loading = false
                  return;
                }
              }
            }
          }

          if (this.isEmpty(stringDates)) {
            stringDates = this.formatDateUs(sdate)
          } else {
            stringDates = stringDates + "," + this.formatDateUs(sdate)
          }
        }
        sdates = stringDates

        stringTimes = ""
        arrayTimes = stimes.split(',')
        for (let j = 0; j < arrayTimes.length; j++) {
          arrayTimes[j] = arrayTimes[j].trim().capitalize(true)

          if ((arrayTimes[j] !== "Déjeuner") && (arrayTimes[j] !== "Diner")) {
            this.text = "Erreur -> Ligne " + (i + 2) + " -> Le moment pour le service est soit Déjeuner et/ou Dîner - cf modèle.";
            this.showAlert('warning')
            vm.loading = false
            return
          }

          if (this.isEmpty(stringTimes)) {
            stringTimes = arrayTimes[j]
          } else {
            stringTimes = stringTimes + "," + arrayTimes[j]
          }
        }
        stimes = stringTimes

        dataTosave.push({
          name: productName,
          price: process.env.VUE_APP_APP_PRODUCT_PRICE,
          description: productDescription,
          listDates: sdates,
          timeMeal: stimes,
          originProduct: originProduct
        });
      }

      apiClient
          .post(`${this.$store.getters.user.baseUrl}/product/createList/` + sessionStorage.getItem("userId"),
              dataTosave
          )
          .then(res => {
            this.removeFile(this.file)

            vm.loading = false
            if (res.data.status === 200) {
              let dataObj = [];
              let dataError = []
              for (let i = 0; i < res.data.datas.length; i++) {
                if (res.data.datas[i].status === 200) {
                  dataObj.push(res.data.datas[i].datas);
                } else {
                  dataError.push(res.data.datas[i]);
                }
              }

              if (dataObj.length > 0 && dataError.length === 0) {
                vm.color = "#009688"
                vm.text = dataObj.length + " menu(s) ajoutée(s) en base.";
                vm.file = "";
                this.showAlert('info')
                this.loadProducts()
              } else if (dataObj.length === 0 && dataError.length > 0) {
                vm.alert = true
                vm.color = "#F44336"
                vm.errors = dataError
                vm.file = "";
              } else if (dataObj.length > 0 && dataError.length > 0) {
                vm.color = "#F44336"
                vm.errors = dataError
                vm.file = "";
                vm.alert = true
              }
            }
          })
          .catch(err => {
            vm.loading = false
            vm.alert = true
            vm.text = err;
            vm.color = "#F44336"
            this.showAlert('warning')
          });
    },
    onexportModele() {
      this.loading = true;

      var ws = XLSX.utils.json_to_sheet([
        {
          productName: "Nom du menu",
          productDescription: "Description",
          planningDates: "Planning du menu",
          timeMeal: "Type de repas",
          originProduct: "MY"
        },
        {
          productName: "Poulet rôti",
          productDescription: "Accompagné de petits poids",
          planningDates: "01/01/2021,02/01/2021,03/01/2021,04/01/2021,05/01/2021,06/01/2021,07/01/2021",
          timeMeal: "Déjeuner,Diner",
          originProduct: "ND"
        },
      ], {
        header: ["productName", "productDescription", "planningDates", "timeMeal", " originProduct"],
        skipHeader: true,
        cellDates: true
      });

      var wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, "Liste_nouveaux_Menus")
      XLSX.writeFile(wb, "Liste_nouveaux_Menus.xlsx", {cellDates: true})

      this.loading = false
    },
    addFile(e) {
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;
      ([...droppedFiles]).forEach(f => {
        this.files.push(f);
      });

      let formData = new FormData();
      this.files.forEach((f, x) => {
        formData.append('file' + (x + 1), f);
      });

      if (!this.files.length) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(this.files[0].name.toLowerCase())) {
        this.text = "Le format du fichier est incorrecte.\nMerci de choisir un format xls ou xlsx";
        this.showAlert('warning');
        return false;
      } else if (this.files.length !== 1) {
        this.text = "Nous ne traitons qu'un fichier excel";
        this.showAlert('warning');
        return false;
      }

      this.file = this.files[0];
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0];
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {defval: "", skipHidden: true});
          const excellist = [];
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          }
          this.total = excellist
              .map(item => item.montant)
              .reduce((prev, curr) => prev + curr, 0);
          this.excelData = excellist.map(function (item) {
            return Object.values(item);
          })

          this.fileBtn = false;
        } catch (e) {
          this.text = "Erreur de lecture du fichier !";
          this.showAlert('warning')
          return false;
        }
      }
      fileReader.readAsBinaryString(this.file);
      const input = document.getElementById("upload");
      input.value = "";
    },
    removeFile(file) {
      this.loading = false
      this.fileBtn = true
      this.drag_over = false
      this.file = ""
      this.files = this.files.filter(f => {
        return f !== file;
      });
    },
    
    // Méthodes pour le nouvel import simplifié
    onBulkImportSuccess(result) {
      this.color = "#009688"
      this.text = result.message || "Import des menus réussi!"
      this.showAlert('info')
      this.dialog = false
      this.tab = "tab-1"
      // Navigate to September 2025 to see the imported menus
      this.focus = '2025-09-01'
      // Recharger les données
      this.refresh()
    },
    
    onBulkImportError(error) {
      this.color = "#F44336"
      this.text = error.message || "Erreur lors de l'import des menus"
      this.showAlert('warning')
    },
  },

  watch: {
    items() {
      if (!this.isMobile) {
        this.convertItemsToCalendarEvents()
      } else {
        this.prepareMobileMenuData()
      }
    }
  },
};
</script>

<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.input-class {
  padding: 2px 0;
  border-bottom: solid 1px #999;
  color: #444;
  width: 100%;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}

.custom-btn2:hover {
  background-color: #F5F5F5 !important;
}

.pre-formatted {
  white-space: pre;
}

/* Desktop Calendar Styles */
.desktop-vuetify-calendar {
  padding: 0;
}

.vuetify-event {
  display: flex;
  align-items: center;
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 2px 4px;
  line-height: 1.2;
}

.event-title {
  font-weight: 500;
  color: white;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Améliorer l'affichage pour les vues semaine et jour */
.v-calendar-weekly__head,
.v-calendar-daily__head {
  background-color: #f5f5f5;
}

/* Mobile view styles */
.mobile-menu-container {
  padding: 16px 8px;
  max-width: 100%;
}

.mobile-day-header {
  background-color: #f5f5f5;
  font-size: 16px;
}

.mobile-menu-item {
  border-bottom: 1px solid #e0e0e0;
  cursor: pointer;
  transition: background-color 0.2s;
}

.mobile-menu-item:hover {
  background-color: #f5f5f5;
}

.mobile-menu-item:last-child {
  border-bottom: none;
}

.mobile-card-header {
  background-color: #01579B;
  color: white;
  font-size: 16px;
  padding: 12px 16px;
  text-align: center;
}

.mobile-menu-card {
  padding: 12px 0;
  cursor: pointer;
  transition: background-color 0.2s;
}

.mobile-menu-card:hover {
  background-color: #f5f5f5;
}

.mobile-cards-container {
  padding: 0;
}

/* Style pour les chips d'heure dans la vue mobile */
.v-chip.v-size--x-small {
  font-size: 10px !important;
  font-weight: 600;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .v-chip-group {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .v-chip-group .v-chip {
    flex-shrink: 0;
  }

  .mobile-menu-container .v-btn-toggle {
    width: 100%;
  }

  .mobile-menu-container .v-btn-toggle .v-btn {
    flex: 1;
  }
}

/* Améliorer l'affichage des événements dans la vue mois */
.v-calendar-monthly .vuetify-event {
  margin-bottom: 1px;
  border-radius: 2px;
}

/* Style pour les événements qui se chevauchent */
.v-calendar .v-event {
  border-radius: 4px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
}
</style>